/* Local dependencies */
import {
  UpdateUserForAdminReset,
  ResetUpdateUserForAdminError,
  UpdateUserForAdminActionTypes,
  UpdateUserForAdminError,
  UpdateUserForAdminInput,
  UpdateUserForAdminRequest,
  UpdateUserForAdminSuccess,
} from './types';

export function updateUserForAdmin(input: UpdateUserForAdminInput): UpdateUserForAdminRequest {
  return {
    type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_REQUEST,
    input,
  };
}

export function updateUserForAdminSuccess(): UpdateUserForAdminSuccess {
  return {
    type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_SUCCESS,
  };
}

export function updateUserForAdminError(error: Error): UpdateUserForAdminError {
  return {
    type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_ERROR,
    error,
  };
}

export function resetUpdateUserForAdminError(): ResetUpdateUserForAdminError {
  return {
    type: UpdateUserForAdminActionTypes.RESET_ERROR,
  };
}

export function resetStateUserForAdmin(): UpdateUserForAdminReset {
  return {
    type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_RESET,
  };
}
